(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bpc-google-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bpc-google-rating')) {
    const requests = new Map();
    const withTimeout = (promise, milliseconds) => new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('Google rating unavailable')), milliseconds);
      Promise.resolve(promise).then(value => { clearTimeout(timer); resolve(value); }, error => { clearTimeout(timer); reject(error); });
    });

    function loadPlaces(key) {
      if (window.google?.maps?.importLibrary) return window.google.maps.importLibrary('places');
      if (!window.bpcGooglePlacesPromise) {
        window.bpcGooglePlacesPromise = withTimeout(new Promise((resolve, reject) => {
          if (document.querySelector('script[src^="https://maps.googleapis.com/maps/api/js"]')) {
            reject(new Error('Google Maps is already loading'));
            return;
          }
          const script = document.createElement('script');
          const url = new URL('https://maps.googleapis.com/maps/api/js');
          url.search = new URLSearchParams({ key, loading: 'async', callback: 'bpcGooglePlacesLoaded', v: 'quarterly', auth_referrer_policy: 'origin' }).toString();
          window.bpcGooglePlacesLoaded = () => {
            delete window.bpcGooglePlacesLoaded;
            window.google.maps.importLibrary('places').then(resolve, reject);
          };
          script.src = url.href;
          script.async = true;
          script.onerror = () => reject(new Error('Google Maps unavailable'));
          const nonce = document.querySelector('script[nonce]')?.nonce;
          if (nonce) script.nonce = nonce;
          document.head.appendChild(script);
        }), 10000);
      }
      return window.bpcGooglePlacesPromise;
    }

    class BpcGoogleRating extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enabled !== 'true' || this.dataset.loaded || !this.dataset.key?.trim() || !this.dataset.place?.trim()) return;
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.refresh(); }
          }, { rootMargin: '120px' });
          this.observer.observe(this);
        } else this.refresh();
      }

      disconnectedCallback() { this.observer?.disconnect(); }

      async refresh() {
        if (this.dataset.loaded) return;
        this.dataset.loaded = 'true';
        try {
          const key = this.dataset.key.trim();
          const id = this.dataset.place.trim();
          const requestKey = `${key}:${id}`;
          if (!requests.has(requestKey)) {
            requests.set(requestKey, withTimeout(loadPlaces(key).then(async ({ Place }) => {
              const place = new Place({ id });
              await place.fetchFields({ fields: ['rating', 'userRatingCount', 'attributions'] });
              return { rating: place.rating, count: place.userRatingCount, attributions: place.attributions || [] };
            }), 12000));
          }
          const { rating, count, attributions } = await requests.get(requestKey);
          if (typeof rating !== 'number' || !Number.isFinite(rating) || rating < 1 || rating > 5 || !Number.isSafeInteger(count) || count < 1) throw new Error('Invalid Google rating');
          const formattedRating = rating.toFixed(1);
          const formattedCount = new Intl.NumberFormat(document.documentElement.lang || 'en').format(count);
          this.querySelector('.bpc-rating-score').textContent = formattedRating;
          this.querySelector('.bpc-rating-fill').style.width = `${rating / 5 * 100}%`;
          this.querySelector('[data-review-count]').textContent = this.dataset.count.replace('[count]', formattedCount);
          this.querySelector('.bpc-rating-freshness').textContent = this.dataset.updated;
          this.querySelector('.bpc-rating').setAttribute('aria-label', this.dataset.label.replace('[rating]', formattedRating).replace('[count]', formattedCount));
          const credits = this.querySelector('.bpc-rating-attributions');
          for (const attribution of attributions) {
            if (typeof attribution.provider !== 'string' || !attribution.provider) continue;
            let href;
            try {
              const url = new URL(attribution.providerURI);
              if (url.protocol === 'https:') href = url.href;
            } catch {}
            const provider = document.createElement(href ? 'a' : 'span');
            provider.textContent = attribution.provider;
            if (href) { provider.href = href; provider.target = '_blank'; provider.rel = 'noopener noreferrer'; }
            if (credits.childNodes.length) credits.append(document.createTextNode(' · '));
            credits.append(provider);
          }
          credits.hidden = !credits.childNodes.length;
          this.dataset.state = 'live';
        } catch {
          this.dataset.state = 'unavailable';
        }
      }
    }
    customElements.define('bpc-google-rating', BpcGoogleRating);
  }
  } catch(e) { console.error(e); }
})();

})();
